import React from 'react';

import { NewPageWrapper, NewPageWrapperCopy } from '../../../ui-components/custom-components';
import { usePracticesLoans } from '../../../contexts/practices-loans-context';
import FormPracticeLoans from '../../../ui-components/forms-components/practice-loans/form-practice-loans';

const NewPracticeLoans = ({ setShowNewPracticeLoans, setPractices}) => {
	const { newPractice, getPractices } = usePracticesLoans();

	const onSubmit = async (form) => {
		const { error } = await newPractice(form);

		if (error !== null) {
			console.log(error.response);
			return ;
		}

		const { data } = await getPractices();
		setPractices(data.data);
		setShowNewPracticeLoans(false);

		window.location.reload();
	}

	return (
		<NewPageWrapper className="new-pratice-page new-page">
			<NewPageWrapperCopy>
				<div className="top-page">
					<h3 className="top-page-title">Nuova Pratica Prestito Personale</h3>
					<button className="close-button" onClick={() => setShowNewPracticeLoans(false)}>&times;</button>
				</div>

				<hr />

				<FormPracticeLoans handleSave={onSubmit} />
			</NewPageWrapperCopy>
		</NewPageWrapper>
	)
}

export default NewPracticeLoans;